var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "v-row",
        [
          _c(
            "v-col",
            { attrs: { cols: "6" } },
            [
              _c(
                "v-row",
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "4" } },
                    [
                      _c("v-text-field", {
                        attrs: { label: "Start", type: "date", clearable: "" },
                        model: {
                          value: _vm.dateStart,
                          callback: function($$v) {
                            _vm.dateStart = $$v
                          },
                          expression: "dateStart"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "4" } },
                    [
                      _c("v-text-field", {
                        attrs: { label: "End", type: "date", clearable: "" },
                        model: {
                          value: _vm.dateEnd,
                          callback: function($$v) {
                            _vm.dateEnd = $$v
                          },
                          expression: "dateEnd"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "12" } },
                    [
                      _c("v-data-table", {
                        attrs: {
                          dense: "",
                          headers: _vm.headers,
                          items: _vm.itemsDeliveredList,
                          "server-items-length": _vm.itemsDeliveredGetCount,
                          loading: _vm.itemsDeliveredGetting,
                          page: _vm.page,
                          "items-per-page": _vm.itemsPerPage
                        },
                        on: {
                          "update:page": function($event) {
                            _vm.page = $event
                          },
                          "update:itemsPerPage": function($event) {
                            _vm.itemsPerPage = $event
                          },
                          "update:items-per-page": function($event) {
                            _vm.itemsPerPage = $event
                          }
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "item",
                            fn: function({ item }) {
                              return [
                                _c("tr", [
                                  _c("td", [
                                    _vm._v(
                                      _vm._s((item.stock || {}).description)
                                    )
                                  ]),
                                  _c("td", [_vm._v(_vm._s(item.quantity))]),
                                  _c("td", [_vm._v(_vm._s(item.unit))])
                                ])
                              ]
                            }
                          }
                        ])
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }